import { Flex, Image, Stack } from '@chakra-ui/react';
import { isCofit } from '../constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var GenesisLogo = function GenesisLogo(_ref) {
  var showText = _ref.showText;
  return showText ? /*#__PURE__*/_jsx(Image, {
    width: 165,
    h: "full",
    alt: "icon",
    src: "/icon.png",
    e2eid: "components_Logo_Image"
  }) : /*#__PURE__*/_jsxs(Flex, {
    h: "full",
    align: "center",
    justify: "center",
    e2eid: "components_Logo_Flex",
    children: [' ', /*#__PURE__*/_jsxs("svg", {
      width: "27",
      height: "30",
      viewBox: "0 0 27 30",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      e2eid: "components_Logo_svg",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M15.5254 13.1871L15.5728 18.7635L26.053 21.9705L25.153 16.2625L15.5254 13.1871Z",
        fill: "#F3C794",
        e2eid: "components_Logo_path"
      }), /*#__PURE__*/_jsx("path", {
        d: "M25.1525 16.2625L7.88672 26.8767L12.967 30L26.0525 21.9705L25.1525 16.2625Z",
        fill: "#F3C053",
        e2eid: "components_Logo_path_4"
      }), /*#__PURE__*/_jsx("path", {
        d: "M12.9671 30L18.0592 26.8648L6.16974 19.5293L0 22.0662L12.9671 30Z",
        fill: "#F8D793",
        e2eid: "components_Logo_path_5"
      }), /*#__PURE__*/_jsx("path", {
        d: "M0.0355263 8.05347L0 22.0662L6.16974 25.8357V10.5425L0.0355263 8.05347Z",
        fill: "#E9AC64",
        e2eid: "components_Logo_path_6"
      }), /*#__PURE__*/_jsx("path", {
        d: "M0.0351562 8.05345V14.3718L18.2128 3.14719L13.1088 0L0.0351562 8.05345Z",
        fill: "#EA8E28",
        e2eid: "components_Logo_path_7"
      }), /*#__PURE__*/_jsx("path", {
        d: "M20.2976 10.6382L8.04102 3.12325L13.1213 0L25.8397 7.81412L20.2976 10.6382Z",
        fill: "#F5B063",
        e2eid: "components_Logo_path_8"
      })]
    })]
  });
};

export var CofitLogo = function CofitLogo(_ref2) {
  var showText = _ref2.showText;
  return showText ? /*#__PURE__*/_jsx(Image, {
    width: 165,
    height: 49,
    alt: "icon",
    src: "/cofit-logo-expanded.svg",
    e2eid: "components_Logo_Image"
  }) : /*#__PURE__*/_jsx(Image, {
    width: 49,
    height: 49,
    alt: "icon",
    src: "/cofit-logo.svg",
    e2eid: "components_Logo_Image_10"
  });
};

var Logo = function Logo(_ref3) {
  var _ref3$showText = _ref3.showText,
      showText = _ref3$showText === void 0 ? false : _ref3$showText;
  return /*#__PURE__*/_jsx(Stack, {
    rounded: "full",
    h: "50px",
    e2eid: "components_Logo_Stack",
    children: isCofit() ? /*#__PURE__*/_jsx(CofitLogo, {
      showText: showText,
      e2eid: "components_Logo_CofitLogo"
    }) : /*#__PURE__*/_jsx(GenesisLogo, {
      showText: showText,
      e2eid: "components_Logo_GenesisLogo"
    })
  });
};

export default Logo;